export const precisionFormatter = (number: number | string, precision = 2): string => {
  return Number(number).toFixed(precision);
};

export const formatNumberWithCommas = (number: number): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const countDecimals = (value: string | number) => {
  if (Math.floor(Number(value)) === Number(value)) return 0;
  return value.toString().split('.')[1].length || 0;
};

export const checkStringIsNumeric = (value: string): boolean => {
  return /^-?[0-9]*(\.\d*)?$/.test(value.trim());
};
